import type { AttachmentRef } from './chat-contracts.js';

export interface AttachmentService {
  resolveObjectUrl: (attachment: AttachmentRef) => Promise<string | undefined>;
  stageAndEncryptFile: (file: File) => Promise<AttachmentRef>;
}

export const defaultAttachmentService: AttachmentService = {
  async resolveObjectUrl(attachment: AttachmentRef): Promise<string | undefined> {
    if (typeof window !== 'undefined' && (window as any).herxAttachmentRepository?.resolveObjectUrl) {
      return (window as any).herxAttachmentRepository.resolveObjectUrl(attachment);
    }
    return (attachment as any).url || undefined;
  },
  async stageAndEncryptFile(file: File): Promise<AttachmentRef> {
    if (typeof window !== 'undefined' && (window as any).herxAttachmentRepository?.stageAndEncryptFile) {
      return (window as any).herxAttachmentRepository.stageAndEncryptFile(file);
    }
    const attachmentId = `att-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    return {
      attachmentId,
      name: file.name,
      mimeType: file.type || 'application/octet-stream',
      sizeBytes: file.size,
      contentHash: `hash-${Date.now()}`,
      storageKey: `local://${file.name}`,
      status: 'confirmed',
      previewable: file.type.startsWith('image/'),
    };
  },
};
